export const FETCH_COURSE_VIDEOS = 'FETCH_COURSE_VIDEOS'
export const CREATE_COURSE_VIDEO = 'CREATE_COURSE_VIDEO'
export const UPDATE_COURSE_VIDEO = 'UPDATE_COURSE_VIDEO'
export const DELETE_COURSE_VIDEO = 'DELETE_COURSE_VIDEO'
export const CHANGE_COURSE_VIDEO_FEATURE = 'CHANGE_COURSE_VIDEO_FEATURE'


export const OPEN_COURSE_VIDEO_FORM  = 'OPEN_COURSE_VIDEO_FORM';
export const CLOSE_COURSE_VIDEO_FORM = 'CLOSE_COURSE_VIDEO_FORM';
